<div class="alert-wrapper" [class.is-empty]="!alert">
    <div class="alert-container">
        <div class="header-container">
            <div class="header-top">
                <div class="icon" (click)="openAlertCenter()"><img [src]="'svg/bell.svg' | assetVersion"></div>
                <span class="title">Alert Center</span>
            </div>
            @if (alert) {
            <div class="alert-details">
                <span class="type">{{ AlertTypeMap[alert.alertType].name }}</span>
                <span class="divider">|</span>
                <span class="logo"><img [src]="alert.logoPath" (error)="onLogoError($event)"></span>
                <span class="brand">{{ utilService.capitalizeFirstLetter(alert.brand) }},</span>
                <span class="date">{{ utilService.formatDateToShort(alert.dateAfter) }}</span>
            </div>
            <div class="alert-description">
                <span> {{ alertDescription }} </span>
            </div>
            }
        </div>
        <div class="chart-container" [ngStyle]="{display: alert ? 'flex' : 'none'}">
            <div id="performance-over-time"></div>
        </div>
        @if (alert) {
        <app-copilot-prompt-bar *ngIf="!loading" [promptControl]="promptControl" [placeholder]="promptBarPlaceholder"
            [shouldDisplayExtraButtons]="false" (sendMessage)="onSendMessage($event)"></app-copilot-prompt-bar>
        <app-suggested-questions [questionsPool]="suggestedQuestions" [questionsAmount]="suggestedQuestionsAmount"
            (questionSelected)="onQuestionSelected($event)"></app-suggested-questions>
        } @else {
        <div class="no-alert-message">
            @if (loading) {
            <app-loader [overlayBackgroundColor]="'transparent'"></app-loader>
            } @else {
            <span class="message-text bold">Something went wrong <br> while loading this alert.</span>
            <span class="message-text">Please try again in a moment.</span>
            }
        </div>
        }
    </div>
</div>
